<template>
    <div>
        <!-- confirm modal -->
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            @show="shown()"
            modal-class="modal-shipping-address"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base" v-if="isShow">
                <div class="modal-base-head">
                    <div class="icon-close" @click="clickCancel()">
                        <img class="img-fluid" src="../../../../assets/icon/otp_icon_close@2x.png">
                    </div>
                    <div class="header-shipping">
                        <div class="text">
                            <p>{{lbl.shipping.headline}}</p>
                        </div>
                    </div>
                </div>
                <div class="modal-base-body">
                    <div class="wrapper-shipping-form">
                        <TextInput
                            inputId="register_firstname"
                            v-model="form.firstName"
                            :inputLbl="lbl.shipping.firstname"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :isRequired="false"
                            :errorInfo="arrErrorInfo[0]"
                            :isTextOnly="true"/>
                        <TextInput
                            inputId="register_lastname"
                            v-model="form.lastName"
                            :inputLbl="lbl.shipping.lastname"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :isRequired="false"
                            :errorInfo="arrErrorInfo[1]"
                            :isTextOnly="true"/>
                        <ContactNumberInput
                            inputId="register_mobile"
                            v-model="form.contactNumber"
                            :inputLbl="lbl.shipping.contactnumber"
                            :inputMaxLength="10"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :errorInfo="arrErrorInfo[2]"
                            :delimeter="'-'"/>
                        <div class="margin-top-3px">
                            <TextAreaInput
                                v-model="form.address"
                                inputId="address"
                                :inputLbl="lbl.shipping.address"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="arrErrorInfo[3]"/>
                        </div>
                        <FormAddressDropdown
                            :address="shippingAddress"
                            formId="shipping"
                            :lblShipping="lbl.shipping"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :zipcodeError="arrErrorInfo[4]"
                            :subDistrictError="arrErrorInfo[5]"
                            :districtError="arrErrorInfo[6]"
                            :provinceError="arrErrorInfo[7]"/>

                        <div class="shipping-checkbox" @click="isChecked = !isChecked">
                            <img v-if="!isChecked" src="../../../../assets/icon/regis_iconcheck_inactive.png"/>
                            <img v-if="isChecked" src="../../../../assets/icon/regis_iconcheck_active.png"/>
                            <span>
                                {{lbl.shipping.save_address}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-confirm" @click="clickOk()">
                        <div class="btn-txt">
                            {{lbl.shipping.confirm_btn}}
                        </div>
                    </div>
                    <!-- <div class="btn-cancel" @click="clickCancel">ยกเลิก</div> -->
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//helper
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
//component
import TextInput from "@/components/Input/Text.vue";
import TextAreaInput from "../../../Input/TextAreaInput.vue";
import ContactNumberInput from "@/components/Input/ContactNumber.vue";
import FormAddressDropdown from "@/components/Form/FormAddressDropDown.vue";
//service
import { AddressModel } from "@/core/Address/model/AddressModel.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ShippingAddressModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String
    },
    components: {
        TextInput,
        ContactNumberInput,
        FormAddressDropdown,
        TextAreaInput,
    },
    data: function() {
        return {
            isShow: false,
            title: "",
            message: "",
            btnOk: "",
            btnCancel: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl(),
            isChecked: true,
            isFirstSave: true,
            arrErrorInfo: [],
            shippingAddress: new AddressModel(),
            shippingProfile: {},
            form: {
                firstName: null,
                lastName: null,
                contactNumber: null,
                address: null,
                zipcode: null,
                provinceCode: null,
                provinceName: null,
                districtCode: null,
                districtName: null,
                subDistrictCode: null,
                subDistrictName: null,
                isSaveAddress: false,
                addressKey: null
            }
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        //error
        for (var i = 0; i <= 10; i++) {
            this.arrErrorInfo.push({
                isValid: true,
                msg: "",
                isCorrect: true
            });
        }
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            //this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.isFirstSave = false;
            this.form.zipcode = this.shippingAddress.zipcode;
            this.form.provinceCode = this.shippingAddress.provinceCode;
            this.form.provinceName = this.shippingAddress.provinceName;
            this.form.districtCode = this.shippingAddress.districtCode;
            this.form.districtName = this.shippingAddress.districtName;
            this.form.subDistrictCode = this.shippingAddress.subDistrictCode;
            this.form.subDistrictName = this.shippingAddress.subDistrictName;
            this.form.isSaveAddress = this.isChecked;
            if (this.validateForm() == false) {
                this.controller.cbAction.sendCallback(this.form);
                this.$nextTick(() => {
                    this.hide();
                });
            }
        },
        validateForm: function() {
            var validate = this.arrErrorInfo.filter(o => !o.isValid);
            return validate.length > 0;
        },
        clickCancel: function() {
            this.isFirstSave = true;
            this.hide();
            this.controller.cbClose.sendCallback({ tag: this.tag });
        },
        shown: function () {
            this.isShow = true;
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }
            if (config.shippingProfile) {
                var shipping = config.shippingProfile;
                this.form.firstName = shipping.firstName;
                this.form.lastName = shipping.lastName;
                this.form.contactNumber = shipping.contactNumber;
                this.form.address = shipping.address;

                this.shippingAddress.zipcode = shipping.zipcode;
                this.shippingAddress.provinceCode = shipping.provinceCode;
                this.shippingAddress.provinceName = shipping.provinceName;
                this.shippingAddress.districtCode = shipping.districtCode;
                this.shippingAddress.districtName = shipping.districtName;
                this.shippingAddress.subDistrictCode =
                    shipping.subDistrictCode;
                this.shippingAddress.subDistrictName =
                    shipping.subDistrictName;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.isShow = false;
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss">
@import "@/style/modal.scss";
.modal-shipping-address {
    .modal-body{
        padding: 28px 20px;
    }
    .modal-dialog {
        width: 100%;
        right: 0;
        margin: auto;
    }

    .modal-content{
        border: none;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        margin-top: 40px;
    }

    .wrapper-shipping-form{
        .wrap-input{
            margin-top: 17px;
            .ddl-input .btn-ddl-input{
                margin-top: 0;
            }
        } 
        .margin-top-3px {
            margin-top: 3px;
        }
    }
}
</style>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/input/BaseInput.scss";
@import "@/style/input/BaseButton.scss";

.modal-shipping-address{
    .modal-base-head{
        .icon-close{
            position: absolute;
            top: 27px;
            right: 25px;

            img{
                width: 17px;
            }
        }
        .header-shipping{
            @include header();
            margin-bottom: 25px;
        }
    } 
    
    .wrapper-shipping-form{
        .shipping-checkbox{
            color: $bright-gray;
            margin: 30px 5px;
            span{
                margin-left: 5px;
            }
        }
    }

    .modal-base-footer{
        .btn-confirm{
            @include btn-wrapper();
            margin-top: 0;
        }
    }
}
</style>
